'use strict';
import {API_KEYS_COLLECTION} from './config';

export function ApiKeysDomainProvider() {
  return {
    $get: ['AbstractDomainClass',
      function (AbstractDomainClass) {
        function ApiKeysDomain(data) {
          AbstractDomainClass.call(this, ApiKeysDomain, data);
        }

        AbstractDomainClass.__inheritFrom(ApiKeysDomain, 'ApiKeysDomain', API_KEYS_COLLECTION);

        //TODO: add perspectives link here.
        ApiKeysDomain.$constraints.addConstraints({
          filepickerApi: {type: 'string'},
          googleApi: {type: 'string'},
          googleMaps: {type: 'string'}
        });

        ApiKeysDomain.$getKeyChain = function () {
          return ApiKeysDomain.$get('current-keys');
        };

        // more methods go here;

        return ApiKeysDomain;
      }]
  };
}




// WEBPACK FOOTER //
// ./src/js/auth/domain/ApiKeysDomain.js